const n=async({signer:s,message:e})=>s.signMessage({message:e});var r=n;export{r as default};
